__webpack_require__.p = "/krupali_portfolio/";